<template>
  <div class="volumelayout">
    <el-container>
      <el-main>
        <div class="div">
          <el-button type="primary" @click="addvolume" :disabled="versions.length < 1">+&nbsp;新增</el-button>
        </div>
        <div class="div2">
          <span>学段</span>
          <div class="btn">
            <el-radio-group size="small" v-model="stageId" @change="changeit">
              <el-radio-button  :label="item.id"  v-for="(item,index ) in stages"  :key="index" >{{item.name}}</el-radio-button>
            </el-radio-group>
          </div>
          <br>
          <div class="clear"></div>
          <span>科目</span>
          <div class="btn">
            <el-radio-group size="small" v-model="subjectId" @change="changeSubject">
              <el-radio-button :label="item.id"  v-for="(item,index ) in subjects"  :key="index" >{{item.name}}</el-radio-button>
            </el-radio-group>
          </div>

          <br>
          <div class="clear"></div>
          <span>版本</span>
          <div class="btn">
            <el-radio-group size="small" v-model="versionId" @change="changeVersion">
              <el-radio-button :label="item.id"  v-for="(item,index ) in versions"  :key="index" >{{item.name}}</el-radio-button>
            </el-radio-group>
            <div v-if="versions.length <1">暂无版本，不可添加册别</div>
          </div>

        </div>

    <el-table
      :data="tableData"
      :height="height"
      header-row-class-name="header-row-class-name"
      :default-sort = "{prop: 'id', order: 'descending'}"
      border
      style="width: 100%">
      <el-table-column
        sortable
        prop="id"
        label="ID号">
      </el-table-column>
      <el-table-column
        sortable
        prop="ordinal"
        label="排序号（可编辑）">
      </el-table-column>
      <el-table-column
        prop="name"
        label="册别名">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.used === true" style="color: #00ff00"> 启用</span>
          <span v-if="scope.row.used === false" style="color: #ff0000">禁用</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作">
        <template slot-scope="scope">
          <el-button  type="text" size="small" @click="editvolume(scope.row.id,scope.row)">编辑</el-button>
          <el-button  type="text" size="small" @click="disable(scope.row.id)" v-if="scope.row.used == true">禁用</el-button>
          <el-button  type="text" size="small" @click="enable(scope.row.id)" v-if="scope.row.used == false">启用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑框 -->
    <edit-dialog  v-model="volumeDialogVisible" :rowData="rowData"  :versionId="versionId" :id="id" @success="editSuccess"></edit-dialog>
      </el-main>
    </el-container>
  </div>
</template>
<script type="text/babel">
import editDialog from './edit-dialog'
import volumeService from '@/service/volumeService'
import commonService from '@/service/commonService'
export default {
  components: {
    editDialog: editDialog
  },
  name: 'volumeManage',
  data () {
    return {
      id: 0,
      stageId: 0,
      subjectId: 0,
      versionId: 0,
      textbookId: 0,
      stages: [],
      subjects: [],
      versions: [],
      textbooks: [],
      height: this.SysConstant.winHeight - 350,
      volumeDialogVisible: false,
      tableData: [],
      rowData: {}
    }
  },
  async mounted () {
    await this.fetchLearnData()

    await this.fetchData()
  },
  methods: {
    async changeit () {
      await this.fetchClassData()
      await this.fetchVersionData()
      await this.fetchData()
    },
    async changeSubject () {
      await this.fetchVersionData()
      await this.fetchData()
    },
    async changeVersion () {
      await this.fetchData()
    },
    /* 获取学段数据 */
    async fetchLearnData () {
      try {
        let data = await commonService.fetchCommonStage()
        if (data) {
          this.stageId = data[2].id
          this.stages = data
        } else {
          this.stages = []
          this.stagesId = 0
        }
        await this.fetchClassData()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    /* 获取科目数据 */
    async fetchClassData () {
      try {
        let data = await commonService.fetchCommonSubject(parseInt(this.stageId))
        if (data && data.length > 0) {
          this.subjectId = data[0].id
          this.subjects = data
        } else {
          this.subjectId = 0
          this.subjects = []
        }
        await this.fetchVersionData()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    /* 获取版本数据 */
    async fetchVersionData () {
      try {
        let data = await commonService.fetchCommonVersion(parseInt(this.subjectId))
        if (data && data.length > 0) {
          this.versionId = data[0].id
          this.versions = data
        } else {
          this.versions = []
          this.versionId = 0
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },

    async fetchData () {
      try {
        let data = await volumeService.fetchData(this.versionId)
        if (data) {
          this.tableData = data
        } else {
          this.tableData = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 启用
    async enable (id) {
      try {
        await volumeService.enableOrDisable({id: id, use: true})
        this.$message.success(this.SysConstant.success)
        this.fetchData()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 禁用
    async disable (id) {
      this.$confirm('此操作将禁用该册别, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await volumeService.enableOrDisable({id: id, use: false})
        this.$message.success(this.SysConstant.success)
        this.fetchData()
      }).catch((e) => {
      //  this.$message.error(e && e.msg)
      })
    },
    addvolume () {
      this.id = 0
      this.volumeDialogVisible = true
    },
    editvolume (id, row) {
      this.id = id
      this.rowData = row
      this.volumeDialogVisible = true
    },
    editSuccess () {
      this.id = 0
      this.rowData = {}
      this.volumeDialogVisible = false
      this.$message.success(this.SysConstant.success)
      this.fetchData()
    }
  }
}
</script>
<style scoped>
  .volumelayout .clear{
   clear:both;
  }

  .volumelayout .div{
    background-color: #ffffff;
    color: #333;
    line-height: 60px;
    height:60px;
    margin-top:-10px;
    margin-bottom:5px;
  }

  .volumelayout .div .el-button{
    background-color: #00aaff;
    color:#fff;
    margin:10px;
    float:left;
  }
  .volumelayout .div2{
    padding:5px 0;
    margin:5px 0;
    background-color: #ffffff;
    color: #333;
    overflow: hidden;
  }
  .volumelayout .div2 span{
    height:50px;
    line-height:50px;
    margin:0 40px;
    float:left;
  }
  .volumelayout .div2 .btn{
    width:80%;
    float:left;
  }

</style>
<style type="text/css">
  .volumelayout .div2 .el-radio-button{
    margin:10px 10px;
    border:1px solid #dcdfe6 !important;
    border-radius:4px !important;
  }
  .volumelayout .div2 .el-radio-button__inner{

    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/layout/volume-manage/index.vue